import React, { ReactElement, CSSProperties } from "react";
import Text from "../Text/Text";
import { isMobileOnly } from "react-device-detect";
import styles from "./TableView.module.css";

interface TableViewProps {
  /**
   * Column Headings
   */
  colHeadings: string[];
/**
   * Table Data
   */
  tableData: any[]
  /**
   * Message to display if no data
   */
  noDataMsg: string
  /**
   * Custom class name to be added to the button
   */
  className?: string;
  /**
   * Add additional styles
   */
  style?: CSSProperties;
}

const TableView: React.FC<TableViewProps> = ({
  colHeadings,
  tableData,
  noDataMsg,
  className,
  style,
  ...rest
}): ReactElement => {
  const renderTableHeader = () => {
    return colHeadings.map((heading: string) => {
      return <th>{heading}</th>;
    });
  };

  const maxWidth = `calc(100% / ${colHeadings.length})`;

  const renderTableData = () => {
    return tableData.map((item) => {
      let header = Object.keys(tableData[0]);
      return (
        <tr>
          {header.map(key => (
            <td style={{ maxWidth: maxWidth }}>{item[key]}</td>
          ))}
        </tr>
      );
    });
  };

  const camelPad = (str: String) => 
  { return str
    .replace(/([A-Z]+)([A-Z][a-z])/g, ' $1 $2')
    .replace(/([a-z\d])([A-Z])/g, '$1 $2')
    .replace(/([a-zA-Z])(\d)/g, '$1 $2')
    .replace(/^./, function(str){ return str.toUpperCase(); })
    .trim();
}

  const renderMobileTableData = () => {
    return tableData.map((item) => {
      let header = Object.keys(tableData[0]);
      return (
        <>
          {header.map(key => (
            <tr className={styles.mobile_row}>
              <th className={key === "DateAdded" ? styles.mobile_objective_row : null}>{camelPad(key)}: </th>
              <td className={key === "DateAdded" ? styles.mobile_objective_row : null} style={{ maxWidth: maxWidth }}>
                {item[key]}
              </td>
            </tr>
          ))}
        </>
      );
    });
  };

  return (
    <table className={`${styles.TableView} ${className}`} style={{ ...style }} {  ...rest}>
      <tbody>
        {tableData && Object.entries(tableData[0]).length !== 0  && tableData.length > 0 ? (
          isMobileOnly ? (
            renderMobileTableData()
          ) : (
            <>
              <tr>{renderTableHeader()}</tr>
              {renderTableData()}
            </>
          )
        ) : (
          <div className={styles.empty_table}>
            <Text wrapper="span" type="body" color="#000000">
              {noDataMsg}
            </Text>
          </div>
        )}
      </tbody>
    </table>
  );
};

export default TableView;
